import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import cn from "classnames";
import { type ComponentPropsWithoutRef } from "react";
import s from "./BurgerIcon.module.css";

export interface BurgerIconProps extends ComponentPropsWithoutRef<"div"> {
  open: boolean;
}

export default function BurgerIcon(props: BurgerIconProps) {
  const { open, ...restProps } = props;

  return (
    <div {...restProps} className={cn(s.wrapper, restProps.className)}>
      {open ? <CloseIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
    </div>
  );
}
